import { List } from "../Components/index.js";

export default [
    {
        path: "/vehicle/indent-list",
        component: List,
        name: "vehicle-indent-list",
        meta: {
            requiresAuth: true,
        },
    },
];
